var _rect, _rect2, _path, _rect3, _rect4, _ellipse, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgDanger = function SvgDanger(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    transform: "matrix(1 0 0 -1 0 100)",
    fill: "none"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 41.5,
    y: 33,
    width: 14.1667,
    height: 36.8333,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M80.4405 59.5603L80.4396 59.5586L62.3072 26.9202C62.3069 26.9197 62.3066 26.9191 62.3063 26.9186C59.5341 21.923 55.2709 18.4791 49.9999 18.4791C44.729 18.4791 40.4658 21.923 37.6936 26.9186C37.6933 26.9191 37.693 26.9197 37.6927 26.9202L19.5602 59.5586L19.5602 59.5586L19.5549 59.5683C16.9088 64.3704 16.3036 69.6096 18.8877 74.0223C21.4765 78.4432 26.3707 80.4725 31.8666 80.4725H68.1333C73.6292 80.4725 78.5234 78.4432 81.1122 74.0223C83.6947 69.6121 83.0941 64.3432 80.4405 59.5603Z",
    fill: "url(#paint0_linear_316_31858)",
    stroke: "white",
    strokeWidth: 6.375
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 47.6001,
    y: 40,
    width: 4.8,
    height: 16.8,
    rx: 2.4,
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 47.6001,
    y: 60,
    width: 4.8,
    height: 4.8,
    rx: 2.4,
    fill: "white"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.6,
    cx: 50,
    cy: 91.5,
    rx: 31,
    ry: 2.5,
    fill: "url(#paint1_linear_316_31858)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_316_31858",
    x1: 64.5,
    y1: 30,
    x2: 29,
    y2: 76,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EF5350"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF5350",
    stopOpacity: 0.61
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_316_31858",
    x1: 88.0455,
    y1: 89.3333,
    x2: 84.8414,
    y2: 107.092,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5ECF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEF8FF",
    stopOpacity: 0.3
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgDanger);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "danger.34e8f3633916bf09192f7e74ca0a1887.svg";